import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_Partaker} from "@/types/iPartaker";
import {I_List} from "@/types/iList";

interface I_AjaxResponse_SavePartaker{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        partakerid:number
    }
}

interface I_PartakerForList extends I_Partaker{
    listid:number
    ,mesaj:string
}

@Component({components:{}})
export default class EditPartakerForList extends Vue {
    @Prop() listid!: number;
    myBoolFalse:boolean=false;
    loading:boolean=false;
    partaker:I_PartakerForList={
        partakerid:0,
        listid:0,
        nume:'',
        last_name:'',
        first_name:'',
        phone:'',
        email:'',
        mesaj:''
    }

    $refs:any;
    private userStore=getModule(User);

    constructor(){
        super();
    }

    async saveGift(ppartaker:I_Partaker){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_SavePartaker>> axios.post(`${CONFIG_ENV.URL_GIFTS.new_partaker_to_list}`,ppartaker);
        return res;
    }


    onReset(){
        const vueInst=this;
        vueInst.partaker={
            partakerid:0,
            listid:0,
            nume:'',
            last_name:'',
            first_name:'',
            phone:'',
            email:'',
            mesaj:''
        };
    }

    onSubmit(){
        const vueInst=this;
        vueInst.saveGift(vueInst.partaker).then(response=>{
            if(response.data.status=='success'){
                vueInst.$emit('infofromchildCommand', 'PARTAKER_SAVED');
            }else{
                vueInst.$q.notify({
                    color: 'red',
                    textColor: 'white',
                    position:'top-right',
                    timeout: 3000,
                    icon: 'fas fa-exclamation-triangle',
                    message: response.data.message
                });
            }
        });
    }

    created(){
        const vueInst=this;
        vueInst.partaker.listid=vueInst.listid;
    }
}
